<template>
  <div :class="containerClasses">
    <div
      v-if="label"
      :for="uniqid"
      class="Form-input__label"
    >
      {{ label }}
    </div>

    <div class="Toggle-input" :class="classes">
      <input
        :id="uniqid"
        :checked="value"
        :disabled="disabled"
        type="checkbox"
        class="Toggle-input__input"
        @change="updateChecked($event.target.checked)"
      />
      <label
        class="Toggle-input__toggler"
        :for="uniqid"
      >
        {{ text }}
      </label>
    </div>
  </div>
</template>

<script>
import formInputMixin from './form-input-mixin'

export default {
  name: 'CheckboxInput',
  mixins: [formInputMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    classes: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateChecked: function (isChecked) {
      this.$emit('touch')
      this.$emit('input', isChecked)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
